// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2-heL","itemTitle":"ClientEmergencyInfo_itemTitle__1X6Ng","itemText":"ClientEmergencyInfo_itemText__24A4P"};